import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Catalog } from '@df/catalog/catalog.interfaces';
import { IProductDataV3 } from '@df/catalog/product/product';
import { ImageModule } from '@df/module-image/image.module';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { defaultImage } from 'projects/app-default/src/app/icms.config';
import { LocalProduct } from '../../../../model/product/product.decorator';

export type ISpecificationSectionItemBlockData = Catalog.IBlockData<ISpecificationSectionItemBlockContent>;

export interface ISpecificationSectionItemBlockContent {
    image?: string;
    title?: string;
    subtitle?: string;
    copy?: string;
}

@Component({
    selector: 'cms-specification-section-item',
    templateUrl: './cms-specification-section-item.html',
    standalone: true,
    imports: [NgClass, ImageModule, ICmsClientModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
@ICmsComponent<CmsSpecificationSectionItemComponent>({
    id: 'cms-specification-section-item',
    block: {
        url: 'cms-specification-section-item'
    },
    name: 'Specification Section Item',
    onDemandOnly: true,
    fields: [
        {
            type: NICmsContentField.EFieldType.image,
            key: 'image',
            title: 'Image',
            required: false,
            default: defaultImage
        },
        {
            type: NICmsContentField.EFieldType.text,
            key: 'title',
            title: 'Title',
            required: false,
            default: 'Water Proof'
        },
        {
            type: NICmsContentField.EFieldType.text,
            key: 'subtitle',
            title: 'Subtitle',
            required: false,
            default: 'Waterproof Rating: > 10000 mm'
        },
        {
            type: NICmsContentField.EFieldType.textarea,
            key: 'copy',
            title: 'Copy',
            required: false,
            description: 'Copy visibly only in modal',
            default: 'Aliquam eget sed eu urna. Ipsum at at tincidunt egestas maecenas proin.'
        }
    ]
})
export class CmsSpecificationSectionItemComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'blockContent'
    })
    content?: ISpecificationSectionItemBlockContent;

    @Input() variant?: string;

    @Input()
    styleVariant?: 'default' | 'modal' = 'default';

    protected get titleClass(): string {
        switch (this.styleVariant) {
            case 'modal':
                return this.client.isX || this.client.isL ? 'h3 m-t-2' : 'h3 m-t-3';
            default:
                return this.client.isX || this.client.isL ? 'h2' : 'h4';
        }
    }
}
